export default __webpack_public_path__ + "static/media/divya.118ae040.png";